import React, { useState, useEffect } from "react";
import { AiFillEye, AiFillGithub } from "react-icons/ai";
import { motion } from "framer-motion";
import { images } from "../../constants";
import { AppWrap, MotionWrap } from "../../wrapper";
import "./Work.scss";

const works = [
  {
    imgUrl: images.mynetdiary,
    title: "MyNetDiary Clone",
    projectLink: "https://mynetdiary-alpha.vercel.app/",
    codeLink: "https://github.com/G-LalithSai/mynetdiary-clone",
    description:
      "Clone of MyNetDiary website using React, Redux, Node.js and Chakra UI. MyNetDiary is used to track and keep a record of diet. 🚴🥗",
    tags: ["React", "Chakra UI", "Node js"],
  },
  {
    imgUrl: images.toggl,
    title: "Toggl Track Clone",
    projectLink: "https://toggl-clone.vercel.app/",
    codeLink: "https://github.com/G-LalithSai/toggl-clone",
    description:
      "Clone of toogl-track website using React, Redux, Node.js and Chakra UI. Toggle is Time tracking, project-management and Reporting website. ⌚📊",
    tags: ["React", "Chakra UI", "Node js"],
  },
  {
    imgUrl: images.bobbi,
    title: "Bobbi Brown Clone",
    projectLink: "https://g-lalithsai.github.io/Bobbi-brown-clone/",
    codeLink: "https://github.com/G-LalithSai/Bobbi-brown-clone",
    description:
      "Clone of bobbibrown.in using HTML, CSS and JavaScript and Bootstrap. Bobbibrown is a platform which sells cosmetics and skin care products. 💄🧴",
    tags: ["HTML - CSS - JS", "Bootstrap"],
  },
  {
    imgUrl: images.lifestyle,
    title: "Lifestyle Stores clone",
    projectLink: "https://g-lalithsai.github.io/LifeStyle-Store/",
    codeLink: "https://github.com/G-LalithSai/LifeStyle-Store",
    description:
      "Lifestyle store clone using HTML, CSS ,JavaScript and bootstrap. Lifestyle is India’s leading fashion destination for the latest trends. 🛍️👘",
    tags: ["HTML - CSS - JS", "Bootstrap"],
  },
];

const Work = () => {
  const [activeFilter, setActiveFilter] = useState("All");
  const [animateCard, setAnimateCard] = useState({ y: 0, opacity: 1 });
  const [filterWorks, setFilterWorks] = useState([]);

  const [touched, setTouched] = useState(null);

  useEffect(() => {
    setFilterWorks(works);
  }, []);

  const handleFilter = (item) => {
    setActiveFilter(item);
    setAnimateCard({ opacity: 0, scale: 0.5, y: -100 });

    setTimeout(() => {
      setAnimateCard({ opacity: 1, scale: 1, y: 0 });
      if (item === "All") {
        setFilterWorks(works);
      } else {
        setFilterWorks(works.filter((work) => work.tags.includes(item)));
      }
    }, 500);
  };

  return (
    <>
      <h2 className="head-text">
        My <span>Projects</span> section
      </h2>

      <div className="app__work-filter">
        {[
          "All",
          "React",
          "HTML - CSS - JS",
          "Node js",
          "Bootstrap",
          "Chakra UI",
        ].map((item, index) => (
          <div
            key={index}
            onClick={() => handleFilter(item)}
            className={`app__work-filter-item app__flex p-text ${
              activeFilter === item ? "item-active" : ""
            }`}
          >
            {item}
          </div>
        ))}
      </div>
      <motion.div
        animate={animateCard}
        transition={{ duration: 0.5, delayChildren: 0.5 }}
        className="app__work-portfolio"
        onClick={() => setTouched(null)}
      >
        {filterWorks.map((work, index) => (
          <motion.div
            className={`app__work-item app__flex ${
              touched === index ? "app__work-touched-nowrap" : ""
            }`}
            key={index}
            onClick={() => setTouched(index)}
            onTouchStart={() => setTouched(index)}
          >
            <div className="app__work-img app__flex">
              <img src={work.imgUrl} alt={work.title} />
              <motion.div
                whileHover={{ opacity: [0, 1] }}
                transition={{
                  duration: 0.25,
                  ease: "easeInOut",
                  staggerChildren: 0.5,
                }}
                className={`app__work-hover app__flex ${
                  touched === index ? "app__work-touched" : ""
                }`}
              >
                <a
                  href={work.projectLink}
                  target="_blank"
                  rel="noreferrer"
                  className={`app__flex ${
                    work.projectLink.toLowerCase() === "na" ? "none" : ""
                  }`}
                >
                  <motion.div
                    whileInView={{ scale: [0, 1] }}
                    whileHover={{ scale: [1, 0.9] }}
                    transition={{ duration: 0.25 }}
                    className="app__flex"
                  >
                    <AiFillEye />
                  </motion.div>
                </a>
                <a
                  href={work.codeLink}
                  target="_blank"
                  rel="noreferrer"
                  className="app__flex"
                >
                  <motion.div
                    whileInView={{ scale: [0, 1] }}
                    whileHover={{ scale: [1, 0.9] }}
                    transition={{ duration: 0.25 }}
                    className="app__flex"
                  >
                    <AiFillGithub />
                  </motion.div>
                </a>
              </motion.div>
            </div>
            <div className="app__work-content app__flex">
              <h4 className="bold-text" title={work.title}>
                {work.title}
              </h4>
              <p
                className="p-text"
                style={{ marginTop: 10 }}
                title={work.description}
              >
                {work.description}
              </p>
              <br />
              <h5>Tech Stacks</h5>
              <div style={{ marginTop: "20px" }}>
                {work.tags.map((tag, index) => (
                  <span
                    className="p-text"
                    style={{
                      margin: "10px 5px",
                      border: "1px solid gray",
                      padding: "5px 10px",
                      whiteSpace: "nowrap",
                      borderRadius: "10px",
                    }}
                    key={index}
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </motion.div>
        ))}
      </motion.div>
    </>
  );
};

export default AppWrap(
  MotionWrap(Work, "app__works"),
  "work",
  "app__primarybg"
);
